
// Local
import Gradient from '../Gradient/gradient'
import { CLASSES as C, COLORS, CONFIG } from '../../globals/constants';
import './style.scss';

export default class Slide {
  constructor(parent, controlPercent, treatmentPercent, width) {
    this.parent = parent;
    this.controlPercent = controlPercent
    this.treatmentPercent = treatmentPercent
    this.width = width

    // draw gradient
    this.gradient = new Gradient(this.parent,
      this.controlPercent, COLORS.champagne, COLORS.green, width, 12);

    // append control circle
    this.parent
      .append('div')
      .attr('class', `${C.CIRCLE}`)
      .classed(`${C.BACKGROUND}`, true)
      .style('left', `${this.controlPercent}%`)

    this.parent
      .append('div')
      .attr('class', `${C.CIRCLE}`)
      .classed(`${C.CONTROL}`, true)
      .style('left', `${this.controlPercent}%`)

    // append treatment circle
    this.treatmentBackgroundCircle = this.parent
      .append('div')
      .attr('class', `${C.CIRCLE}`)
      .classed(`${C.BACKGROUND}`, true)
      .style('left', `${this.controlPercent}%`)


    this.treatmentCircle = this.parent
      .append('div')
      .attr('class', `${C.CIRCLE}`)
      .classed(`${C.TREATMENT}`, true)
      .style('left', `${this.controlPercent}%`)

  }

  /* Things that need to update */
  // note - using arrow function's lexical binding to bind "this" context to Slide instance
  draw = () => {

    // translate circles
    // append treatment circle
    this.treatmentBackgroundCircle
      .transition()
      .duration(CONFIG.DURATION)
      .style('left', `${this.treatmentPercent}%`)

    this.treatmentCircle
      .transition()
      .duration(CONFIG.DURATION)
      .style('left', `${this.treatmentPercent}%`)

    const arrowPercentLeft = this.controlPercent < this.treatmentPercent ? this.controlPercent : this.treatmentPercent
    const arrowPercentRight = this.controlPercent < this.treatmentPercent ? 100 - this.treatmentPercent : 100 - this.controlPercent;
    // append arrow
    const arrow = this.parent
      .append('div')
      .attr('class', `${C.ARROW}`)
      .classed(`${C.ARROW}-${C.RIGHT}`, this.controlPercent < this.treatmentPercent)
      .classed(`${C.ARROW}-${C.LEFT}`, this.controlPercent > this.treatmentPercent)
      .classed(`${C.NARROW}`, Math.abs(this.treatmentPercent - this.controlPercent) < 4)

    if (this.controlPercent > this.treatmentPercent) {
      arrow
        .style('right', `${arrowPercentRight}%`)
        .style('left', `${this.controlPercent}%`)
        .transition()
        .duration(CONFIG.DURATION)
        .style('left', `${arrowPercentLeft}%`)

    } else {
      arrow
        .style('right', `${100 - this.controlPercent}%`)
        .style('left', `${arrowPercentLeft}%`)
        .transition()
        .duration(CONFIG.DURATION)
        .style('right', `${arrowPercentRight}%`)
    }

  }
}
